import { createReducer, on } from '@ngrx/store';
import { TreeNode } from 'primeng/api';
import { selectNode, toggleNode, loadTeamsSuccess, refreshTree } from './TeamsLocationAction';

export interface TeamsLocationState {
  expandedKeys: { [key: string]: boolean };
  selectedKey?: string;
  categories: TreeNode[];
  loading: boolean;
}

export const initialTeamsLocationState: TeamsLocationState = {
  expandedKeys: {},
  selectedKey: undefined,
  categories: [],
  loading: false
};

export const TeamsLocationReducer = createReducer(
  initialTeamsLocationState,
  on(toggleNode, (state, { key, expanded }) => ({
    ...state,
    expandedKeys: { ...state.expandedKeys, [key]: expanded }
  })),
  on(selectNode, (state, { key }) => ({
    ...state,
    selectedKey: key
  })),
  on(loadTeamsSuccess, (state, { categories }) => ({
    ...state,
    categories,
    loading: false
  })),
  on(refreshTree, (state) => ({
    ...state,
    loading: true
  }))
);
